import { render, staticRenderFns } from "./CasperAccessCard.vue?vue&type=template&id=0db51352&scoped=true&"
import script from "./CasperAccessCard.vue?vue&type=script&lang=js&"
export * from "./CasperAccessCard.vue?vue&type=script&lang=js&"
import style0 from "./CasperAccessCard.vue?vue&type=style&index=0&id=0db51352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db51352",
  null
  
)

export default component.exports